import ErrorBoundary from "../../containers/ErrorBoundary";
import ErrorComponent from "./ErrorComponent";
import FaceAndBodyCarouselSkeleton from "./FaceAndBodyCarouselSkeleton";
import loadable from "@loadable/component";

const FaceAndBodyCarouselLoader = loadable(
  () =>
    import(
      /* webpackPreload: true, webpackChunkName: "FACE_AND_BODY_CAROUSEL" */ "./FaceAndBodyCarouselContainer"
    ),
  { fallback: <FaceAndBodyCarouselSkeleton /> }
);

const FaceAndBodyCarousel = props => (
  <ErrorBoundary ErrorComponent={ErrorComponent}>
    <FaceAndBodyCarouselLoader {...props} />
  </ErrorBoundary>
);

export default FaceAndBodyCarousel;
